export default __webpack_public_path__ + "static/media/princeton-university-logo.af1609d1.webp";